module.exports = __webpack_public_path__ + "static/bg-12-f17b13a929487edbe05e3f81227051bc.jpg";